import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import RaffleCard from "@/components/site/RaffleCard";

export default function Raffles() {
  const [raffles, setRaffles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/raffles");
        setRaffles(r.data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="raffles-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="font-mono-retro text-xs tracking-[0.4em] text-[#C8A96A] uppercase">The Fixture List</div>
      <h1 className="font-display text-5xl md:text-6xl text-[#F2EBDD] mt-2">All Raffles</h1>
      <p className="text-[#A8A39D] mt-3 max-w-2xl">Buy a ticket, take your shot. Prizes range from match-worn shirts to box seats and football history.</p>

      <div className="mt-12">
        {loading ? (
          <div className="font-mono-retro text-sm tracking-[0.2em] text-[#A8A39D] uppercase">Loading fixtures…</div>
        ) : raffles.length === 0 ? (
          <div className="border border-dashed border-[#332D2B] p-16 text-center">
            <div className="font-display text-3xl text-[#F2EBDD]">No Raffles On The Card</div>
            <p className="text-[#A8A39D] mt-3">Come back next matchday for new fixtures.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {raffles.map((r) => <RaffleCard key={r.id} raffle={r} />)}
          </div>
        )}
      </div>
    </div>
  );
}
